



























import { Mixins, Component, Prop, Emit } from 'vue-property-decorator'
import TcwFormItemCommon from '@/components/common/form/mixins/TcwFormItemCommon'

@Component
export default class TcwFormItemNumber extends Mixins(TcwFormItemCommon) {
  @Prop({ default: null })
  private value!: number | null
  @Prop({ default: 1 })
  private precision!: number
  @Prop({ default: 1 })
  private step!: number
  @Prop({ default: false })
  private stepStrictly!: boolean

  @Emit()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private input(value: string): void {
    /**  */
  }

  @Emit()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private change(value: string): void {
    /**  */
  }
}
